import { defineAction } from '~/prix'
import { z } from 'zod'
import semenStockUpdateAction from './semenStockUpdate.action.json' with { type: 'json' }
import { semenStockObject } from '../semenStockObject'

const semenStockUpdateDefinition = defineAction({
  ...semenStockUpdateAction,

  input: semenStockObject
    .pick({
      id: true,
      bullId: true,
      quantity: true,
      type: true,
      buyDate: true,
      noteNumber: true,
      supplier: true,
      semenType: true,
      semenBatchId: true,
      unityValue: true,
    })
    .partial({
      bullId: true,
      quantity: true,
      type: true,
      buyDate: true,
      noteNumber: true,
      supplier: true,
    }),
  output: z.object({}),
})

export default semenStockUpdateDefinition
